<script lang="ts">
  import Maze from "./maze";
  import MazeDisplay from "./MazeDisplay.svelte";
  import * as utils from "./utils";

  export let maze: Maze;

  let selected = 0;

  function onClickCell(event) {
    const { x, y } = event.detail;
    maze.grid[y][x] = selected;
  }

  function onNew() {
    const width = prompt("Enter width");
    if (!width) return;
    const height = prompt("Enter height");
    if (!height) return;

    maze = Maze.basicMaze(parseInt(width), parseInt(height));
  }

  function onSave() {
    const data = JSON.stringify(maze.grid);
    utils.download(data, "maze.json", "application/json");
  }

  let fileInput;
  function onLoad() {
    fileInput.click();
  }
  function onLoaded(event) {
    const reader = new FileReader();
    reader.readAsText(event.target.files[0]);
    reader.onload = (e) => {
      if (typeof e.target.result === "string") {
        maze = new Maze(JSON.parse(e.target.result));
      }
    };
    event.target.value = "";
  }
</script>

<div class="my-2">
  <div class="btn-group">
    <button class="btn btn-secondary" on:click={onNew}>New</button>
    <button class="btn btn-secondary" on:click={onSave}>Save</button>
    <button class="btn btn-secondary" on:click={onLoad}>Load</button>
  </div>
</div>

<div class="toolbar my-2">
  <div
    class="toolbar-option empty"
    title="Empty"
    on:click={() => (selected = 0)}
    class:selected={selected == 0}
  />
  <div
    class="toolbar-option wall"
    title="Wall"
    on:click={() => (selected = 1)}
    class:selected={selected == 1}
  />
  <div
    class="toolbar-option robot"
    title="Player"
    on:click={() => (selected = 2)}
    class:selected={selected == 2}
  />
  <div
    class="toolbar-option target"
    title="Target"
    on:click={() => (selected = 3)}
    class:selected={selected == 3}
  />
</div>

<MazeDisplay on:cell={onClickCell} grid {maze} />

<input
  class="hide"
  type="file"
  accept="application/json"
  on:change={onLoaded}
  bind:this={fileInput}
/>

<style>
  .toolbar-option {
    width: 32px;
    height: 32px;
    border: 1px solid gray;
    display: inline-block;
    box-sizing: border-box;
    cursor: pointer;
  }

  .toolbar-option.selected {
    border: 4px solid black;
  }

  .wall {
    background-color: gray;
  }

  .robot {
    background-color: red;
  }

  .target {
    background-color: yellowgreen;
  }

  .hide {
    position: fixed;
    top: -1000px;
  }
</style>
